import { Row, Col } from "rsuite";
import { DashCircle, PlusCircle } from "react-bootstrap-icons";

interface PassengerCounterProps {
  label: string;
  count: number;
  onIncrement: () => void;
  onDecrement: () => void;
}

export const PassengerCounter: React.FC<PassengerCounterProps> = ({
  label,
  count,
  onIncrement,
  onDecrement
}) => {
  return (
    <Row>
      <Col style={{ textAlign: 'left' }} xs={18}>{label}</Col>
      <Col xs={2} style={{ textAlign: 'right' }}>
        <DashCircle style={{ fontSize: '20px' }} onClick={onDecrement} />
      </Col>
      <Col xs={1}> {count} </Col>
      <Col xs={2} style={{ textAlign: 'left' }}>
        <PlusCircle style={{ fontSize: '20px' }} onClick={onIncrement} />
      </Col>
    </Row>
  );
};
